export default __webpack_public_path__ + "static/media/logoBmoonLight.f68a78d1.png";